module.exports = __webpack_public_path__ + "static/media/focus-active.f3011e2c.png";